import { Component, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-update-banner',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  template: `
    <div class="update-banner">
      <div class="update-banner__content">
        <div class="update-banner__icon">
          <i class="pi pi-refresh"></i>
        </div>
        <div class="update-banner__text">
          <span class="update-banner__title">New Version Available</span>
          <span class="update-banner__message">
            The application has been updated in the background. Please refresh to get the latest features.
          </span>
        </div>
      </div>
      <div class="update-banner__actions">
        <p-button
          label="Refresh Now"
          icon="pi pi-sync"
          [outlined]="true"
          styleClass="btn-outlined"
          (onClick)="onRefresh()"
        ></p-button>
      </div>
    </div>
  `,
  styles: [`
    .update-banner {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: linear-gradient(135deg, #0b435b 0%, #1a6b8a 100%);
      color: white;
      padding: 0.75rem 1.5rem;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      z-index: 10000;
      animation: slideDown 0.3s ease-out;
      gap: 1rem;

      &__content {
        display: flex;
        align-items: center;
        gap: 1rem;
        flex: 1;
      }

      &__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.5rem;
        height: 2.5rem;
        background: rgba(255, 255, 255, 0.15);
        border-radius: 50%;
        flex-shrink: 0;

        i {
          font-size: 1.25rem;
          animation: rotate 2s linear infinite;
        }
      }

      &__text {
        display: flex;
        flex-direction: column;
        gap: 0.125rem;
      }

      &__title {
        font-weight: 600;
        font-size: 0.95rem;
      }

      &__message {
        font-size: 0.85rem;
        opacity: 0.9;
      }

      &__actions {
        flex-shrink: 0;
      }
    }

    /* Keep the outlined button visible on the dark banner at all interaction states */
    :host ::ng-deep .btn-outlined.p-button {
      color: #fff !important;
      border-color: rgba(255, 255, 255, 0.7) !important;
      background: transparent !important;

      &:hover,
      &:focus-visible {
        background: rgba(255, 255, 255, 0.15) !important;
        border-color: #fff !important;
        color: #fff !important;
      }

      &:active {
        background: rgba(255, 255, 255, 0.25) !important;
        border-color: #fff !important;
        color: #fff !important;
      }

      .p-button-icon,
      .p-button-label {
        color: inherit;
      }
    }

    @keyframes slideDown {
      from {
        transform: translateY(-100%);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }

    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    @media (max-width: 640px) {
      .update-banner {
        flex-direction: column;
        text-align: center;
        padding: 1rem;

        &__content {
          flex-direction: column;
        }

        &__text {
          align-items: center;
        }

        &__message {
          display: none;
        }
      }
    }
  `],
})
export class UpdateBannerComponent {
  refresh = output<void>();

  onRefresh(): void {
    this.refresh.emit();
  }
}
